import { useIntl } from 'gatsby-plugin-intl';

type MDXNodeMeta = {
  fields?: {
    filename?: string | null;
  } | null;
};

type MDXPageData<T> = {
  allMdx: {
    nodes: T[];
  };
};

export const useMDXNode = <T extends MDXPageData<U>, U extends MDXNodeMeta>(data: T): T['allMdx']['nodes'][number] => {
  const { locale, defaultLocale } = useIntl();

  const ownNode =
    data.allMdx.nodes.find((node) => node.fields?.filename === locale) ||
    data.allMdx.nodes.find((node) => node.fields?.filename === defaultLocale);

  if (!ownNode) {
    throw new Error('Cannot find mdx node for the current page');
  }

  return ownNode;
};
